export default __webpack_public_path__ + "static/media/Property 1=Closed.d6827f35.svg";